<div class="p-2 min-w-[80%] md:mr-3">
	<div class="flex items-center gap-2 mb-5">
		<img ngSrc="https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/logo-brown.svg" width="40" height="40" alt="Anuprerna">
		<h1 class="text-2xl uppercase text-[#8E7862]">Anuprerna</h1>
	</div>
	<div class="fb-login-form-container flex flex-col items-stretch">
		<div class="flex gap-2 items-center">
			<span (click)="authProvider.emit(AuthProviderEnum.UNKNOWN)"
				  class="material-symbols-outlined cursor-pointer">
				arrow_back_ios
			</span>
			<h3 class="font-medium text-2xl mb-2">Continue with {{ aProvider.toLowerCase() }}</h3>
		</div>

		<p class="text-[#9fa6b8]">We’ll check if you have an account, and help create one if you don’t.</p>
	</div>
</div>
